// notifications.module.ts
import { NgModule } from '@angular/core';
import { SimpleNotificationsModule } from 'angular2-notifications';

@NgModule({
  imports: [
    SimpleNotificationsModule.forRoot({
      position: ['bottom', 'right'],
      timeOut: 3000,
      lastOnBottom: true,
    })
  ],
  exports: [SimpleNotificationsModule]
})
export class NotificationsConfigModule { }
